module.exports = __webpack_public_path__ + "static/img/1077.e5dc9a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1077.jpg
// module id = 259
// module chunks = 0